import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { hasVisibleContent } from './hasVisibleContent';

/**
 * Determine if a `CalendarEvent` has visible content in its body
 *
 * Useful for deciding whether or not to show a UI element for rendering the event description
 */
export function hasVisibleContentInBody(item: CalendarEvent): boolean {
    // handle nil value
    if (!item) {
        return false;
    }
    // perform cheap checks for early return
    if (item.Preview && item.Preview.length > 0) {
        return true;
    }
    if (!item.Body || !item.Body.Value) {
        return false;
    }

    return hasVisibleContent(item.Body.Value);
}
